/**
 * 翻译阶段控制器
 */
export interface TranslateStageController {
    /**
     * 重启翻译任务
     * @param taskId 任务ID
     */
    restart(taskId: string): Promise<void>;
    /**
     * 初始化
     * @param taskId 任务ID
     */
    init(taskId: string): Promise<void>;
    /**
     * 执行下一步
     */
    next(): Promise<void>;
    /**
     * 执行上一步
     */
    prev(): Promise<void>;
}

export const TranslateStageController = Symbol('TranslateStageController');
